// MUI

/* istanbul ignore next */
var getThemeOptions = function getThemeOptions(fontName) {
  var fontFamilyNames = 'boschsans,Roboto,Helvetica,Arial,sans-serif';
  return {
    typography: {
      fontFamily: fontName ? fontName : fontFamilyNames
    },
    palette: {
      primary: {
        main: '#007bc0'
      },
      info: {
        main: '#000000'
      },
      background: {
        "default": '#8a9097',
        paper: '#ffffff'
      }
    },
    shape: {
      borderRadius: 0
    },
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
          disableTouchRipple: true
        }
      }
    }
  };
};
export { getThemeOptions };